import { api } from 'app/api';
import { IId, IPaginatedResponse } from 'types';
import {
  ICreateTDPTemplateMutation,
  ICreateTemplateSectionMutation,
  IEditTDPTemplateMutation,
  ITemplate,
  ITemplateSection,
} from './types';

export interface ITDPTemplatesParams {
  limit: number;
  offset: number;
}

export const tdpTemplateApi = api.injectEndpoints({
  endpoints: (build) => ({
    TDPTemplates: build.query<IPaginatedResponse<ITemplate>, Partial<ITDPTemplatesParams>>({
      query: (args) => ({
        url: '/templates/',
        params: { ...args },
      }),
      providesTags: ['tdpTemplates'],
    }),
    TDPTemplate: build.query<ITemplate, { id: number | string }>({
      query: ({ id }) => ({
        url: `/templates/${id}/`,
      }),
      providesTags: ['tdpTemplates'],
    }),
    createTDPTemplate: build.mutation<ITemplate, ICreateTDPTemplateMutation>({
      query: (body) => ({
        url: `/templates/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['tdpTemplates'],
    }),
    editTDPTemplate: build.mutation<void, IEditTDPTemplateMutation>({
      query: ({ id, ...body }) => ({
        url: `/templates/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['tdpTemplates'],
    }),
    deleteTDPTemplate: build.mutation<void, IId>({
      query: ({ id }) => ({
        url: `/templates/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['tdpTemplates'],
    }),
  }),
});

export const {
  useTDPTemplatesQuery,
  useTDPTemplateQuery,
  useCreateTDPTemplateMutation,
  useEditTDPTemplateMutation,
  useDeleteTDPTemplateMutation,
} = tdpTemplateApi;
